export enum SaleTypes {
  acquisition = 'Acquisition',
  condo = 'Condo',
  entityLevel = 'Entity-Level',
  ownerUser = 'Owner-User',
  transfer = 'Transfer',
}
